import styled from "styled-components";
import TableItem from "../../../components/Table/TableItem";
import FirstTableItem from "../../../components/Table/FirstTableItem";

export const MainContainer = styled.div`
  flex-direction: row;
  background: #f6f6f9;

  min-height: 100vh;
  display: flex;
  height: 100%;
`;

export const Column = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  margin-top: 75px;

  transition: all 0.3s ease-in-out;
  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "8rem 30rem 8rem 4rem"
          : "8rem 4rem 8rem 30rem"
        : !props.$ar
        ? "8rem 4rem 8rem 10rem"
        : "8rem 10rem 8rem 4rem"
      : "8rem 4rem"};

  @media (max-width: 870px) {
    margin-top: 50px;
    padding: ${(props) =>
      props.$upgradePackage ? "60px 40px 40px 40px" : "0px 40px 40px 40px"};
  }
  @media (max-width: 760px) {
    align-items: center;
  }
`;

export const TabName = styled.span`
  margin-top: ${(props) => (props.$isBankTransfers ? "20px" : "80px")};
  font-family: "Avenir-Black", sans-serif;
  font-size: 35px;
  line-height: 48px;
  letter-spacing: -0.177777px;

  color: #484888;
  @media (max-width: 870px) {
    margin-top: 20px;
  }
`;
export const Content = styled.div`
  width: 100%;
  max-width: 100%;
  border: 1px solid #48488877;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 25px;
  padding: 2rem;
`;

export const Text = styled.span`
  letter-spacing: -0.177777px;
  color: #484888;
  font-family: "Avenir-Heavy";
  font-style: normal;
  font-size: 24px;
  // line-height: 33px;
  letter-spacing: -0.177777px;
  text-align: center;

  color: #484888;
  @media (max-width: 990px) {
    font-size: 20px;
  }
  @media (max-width: 850px) {
    font-size: 17px;
  }
  @media (max-width: 870px) {
    font-size: 22px;
  }
  @media (max-width: 650px) {
    font-size: 18px;
  }
  @media (max-width: 540px) {
    font-size: 14px;
  }
`;

export const Desc = styled.span`
  font-family: "Avenir-Light";
  font-style: normal;

  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.177777px;

  color: rgba(69, 69, 132, 0.6);
`;

export const TextContainer = styled.div`
  display: flex;
  margin-top: 10%;
  margin-bottom: 10%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
  margin-top: 40px;
  align-items: center;
  justify-content: center;
`;

export const Buttons = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 15px;
  align-items: center;
  font-family: "Avenir-Medium";
  font-style: normal;

  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.177777px;
  color: #ffffff;
  gap: 10px;
  justify-content: center;
  background: linear-gradient(180deg, #7f7fac 0%, #484888 100%), #ffffff;
  border-radius: 15px;
  &:hover {
    background: #484888;
  }
  &:active {
    transition: all 0.2s ease;
    transform: scale(0.95);
  }
`;

export const TableBodyRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  display: flex;
  width: 100%;
  background-color: ${(props) => props.$active && "#48488815"};

  cursor: ${(props) => (props.$offClick ? "default" : "pointer")};

  min-height: 6.4rem;
  gap: 4rem;

  &:last-of-type {
    border-bottom: none;
  }
  &:hover {
    background-color: #48488815;
    transition: all 0.2s ease-in-out;
  }
  &:nth-child(even) {
    background-color: #48488810;
  }
`;

export const FirstItem = styled(FirstTableItem)`
  padding-left: 18px;
`;

export const LastTableItem = styled(TableItem)`
  padding-right: 16px;

  justify-content: flex-end;
  cursor: ${(props) => (props.$offClick ? "default" : "pointer")};

  &:active {
    opacity: ${(props) => (props.$offClick ? 1 : 0)};
  }
`;
export const StyledTable = styled.table`
  width: 100%;
`;
export const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 80px;
  width: 1800px;
  @media (max-width: 2125px) {
    width: 100%;
  }
`;

export const DetailsTd = styled.td`
  text-align: center;
`;

export const InvoiceTd = styled.td`
  text-align: center;
`;

export const BalanceContainer = styled.div`
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;
export const BalanceValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
export const Balance = styled.span`
  font-family: "Avenir-Medium";

  font-size: 24px;
  letter-spacing: -0.18px;
  color: #484888;
`;
export const BalanceValue = styled.span`
  font-family: "Avenir-Heavy";

  font-size: 24px;
  letter-spacing: -0.18px;
  color: #484888;
`;
export const StyledTd = styled.td`
  text-align: center;
  min-width: 150px !important;
  font-family: "Avenir-Medium";
`;
export const StyledTdAll = styled(StyledTd)`
  padding-bottom: 10px;
`;
export const Option = styled.option`
  border: none;
  padding: 8px;
  background: transparent;
  width: 100%;
  font-family: "Avenir-Medium";
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.177777px;
  color: #484888;
`;
export const Select = styled.select`
  border: none;
  background: transparent;
  font-family: "Avenir-Medium";
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.177777px;
  color: #484888;
  text-align: center;

  &:focus {
    outline: none;
  }
`;

export const StyledTdFirst = styled(StyledTd)`
  text-align: left;
  min-width: unset !important;
  padding-bottom: 10px;
`;

export const StyledTh = styled.th`
  text-align: center;
  font-family: "Avenir";
`;

export const LoaderDiv = styled.div`
  margin-top: 150px;
  @media (max-height: 870px) {
    margin-top: 100px;
  }

  @media (max-height: 550px) {
    margin-top: 40px;
  }

  @media (max-height: 450px) {
    margin-top: 20px;
  }
`;

export const StyledAHref = styled.a`
  cursor: pointer;
`;

export const HeaderWrapper = styled.div`
  background: #484888;
  position: fixed;
  z-index: 1000;
  width: 100%;
`;
